module.exports = __webpack_public_path__ + "img/bestIcon.0b89445a.svg";